import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { LoaderService } from '@monsido/core/loader/loader.service';
import { EndpointsModule } from '@monsido/modules/endpoints/endpoints.module';

import { OauthModule } from '@monsido/oauth/oauth.module';
import { CoreModule } from '@monsido/core/core.module';
import { PagesModule } from '@monsido/pages/pages.module';
import { AccesibilityModule } from '@monsido/modules/accessibility/accessibility.module';

export function init_app (appLoadService: LoaderService) {
    return (): Promise<unknown> => appLoadService.initializeApp();
}

@NgModule({
    imports: [EndpointsModule, OauthModule, CoreModule, PagesModule, AccesibilityModule],
    exports: [],
    declarations: [],
    providers: [
        LoaderService,
        provideAppInitializer(() => {
            const initializerFn = (init_app)(inject(LoaderService));
            return initializerFn();
        }),
    ],
})
export class LoaderModule {}
